import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import axios from "axios";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { MyDomain } from "../../App";
export default function AdminProductsGet() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { User, Token } = useAppContext();
  const [Data, setData] = useState([]);
  console.log(User);
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  const fetchData = async () => {
    console.log("1");
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    console.log("2");

    try {
      const response = await axios.get(`${MyDomain}Products/GetAllProducts`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        //params: { Id: User.userId },
      });
      console.log(response.data);
      setData(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.response.data.error);
      setLoading(false);
    }
  };

  console.log(Data);
  useEffect(() => {
    fetchData();
  }, [User, Token]); // Run when User or Token changes
  const DropDownOrDialogRenderer = (params) => {
    return params.value === 1 ? <a>Drop down</a> : <a>Dialog</a>;
  };
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "id",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "productId",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "name",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
      //   headerCheckboxSelection: true,
      //   headerCheckboxSelectionFilteredOnly: true,
      //   checkboxSelection: true,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "image",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "discount",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}%`,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "category",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "deals",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "category",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "discId",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },

    {
      flex: width > 766 ? 1 : null,
      field: "dropDown",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },

    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "theDeal",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },

    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "dropDownOrDialog",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      cellRenderer: DropDownOrDialogRenderer,
    },

    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "numberUsersRating",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },

    {
      flex: width > 766 ? 1 : null,
      field: "rating",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "datePost",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "brand",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "productType",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "classfication",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "productProperties",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "gender",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "scentType",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },

    {
      flex: width > 766 ? 1 : null,
      field: "topNote",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "heartNote",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "baseNote",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "ingredients",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "specialCertificates",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "volume",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "madeIn",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "price",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `₪ ${params.value}`,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "color",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "protectionLevel",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "eyeshadowEffect",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "Formula",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "country",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "hairType",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "BrushMaterial",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "skinType",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "age",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "line",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "bigCategoryFilter",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "isGift",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "checkGiftName",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "newsCodeCat",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "dateCreateProduct",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    // {
    //   minWidth: 150,
    //   flex: width > 766 ? 1 : null,
    //   field: "AppBundle",
    //   filter: "agNumberColumnFilter",
    //   headerClass: "my-header-class",

    //   valueFormatter: (params) => `${params.value}`,
    // },
    // {
    //   minWidth: 150,
    //   flex: width > 766 ? 1 : null,
    //   field: "OS",
    //   filter: "agNumberColumnFilter",
    //   headerClass: "my-header-class",

    //   valueFormatter: (params) => `${params.value}`,
    // },
    // {
    //   minWidth: 150,
    //   flex: width > 766 ? 1 : null,
    //   field: "Fill",
    //   filter: "agNumberColumnFilter",
    //   headerClass: "my-header-class",

    //   valueFormatter: (params) =>
    //     `${params.value.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`,
    // },
    // {
    //   minWidth: 150,
    //   flex: width > 766 ? 1 : null,
    //   field: "Revenue",
    //   filter: "agNumberColumnFilter",
    //   headerClass: "my-header-class",

    //   valueFormatter: (params) =>
    //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    // },
    //   {
    //     minWidth: 150,
    //     flex: width > 766 ? 1 : null,
    //     field: "Fill",
    //     filter: "agNumberColumnFilter",
    //     headerClass: "my-header-class",

    //     valueFormatter: (params) =>
    //       `${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    //   },
    //   {
    //     minWidth: 150,
    //     flex: width > 766 ? 1 : null,
    //     field: "Revenue",
    //     filter: "agNumberColumnFilter",
    //     headerClass: "my-header-class",

    //     valueFormatter: (params) =>
    //       `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    //   },
    //   {
    //     minWidth: 150,
    //     flex: width > 766 ? 1 : null,
    //     field: "QS",
    //     filter: "agNumberColumnFilter",
    //     headerClass: "my-header-class",

    //     //   parseFloat(text) >= 5
    //     //   ? "#10b981"
    //     //   : parseFloat(text) > 2 && parseFloat(text) < 5
    //     //   ? "#fdba74"
    //     //   : "#f43f5e",

    //     cellStyle: (params) =>
    //       params.value >= 5
    //         ? { color: "black", backgroundColor: "green" }
    //         : params.value > 2 && params.value < 5
    //         ? { color: "black", backgroundColor: "orange" }
    //         : { color: "black", backgroundColor: "red" },
    //     valueFormatter: (params) => `$ ${params.value}`,
    //   },
  ]);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === Data.length ? "bottom-row" : "";
    },
    // other grid options...
  };
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    // "rag-amber-outer": function (params) {
    //   return params.value === 2004;
    // },
    // "rag-red-outer": function (params) {
    //   return params.value === 2000;
    // },
  };
  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true, // Add this line to enable resizing
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  if (loading) return <a>loading...</a>;
  if (error) return <a>{error}</a>;

  return (
    <div>
      <div style={{ paddingTop: 30 }}>
        <div style={containerStyle}>
          <div style={gridStyle} className="ag-theme-alpine">
            <span style={{ color: "#1a1523", fontSize: 18 }}>
              All Products
              {/* <span style={{ color: "#e4e2e4" }}> • </span>{" "}
            <span style={{ color: "#6f6e77" }}>{startDate}</span> */}
            </span>
            <AgGridReact
              cellClassRules={ragCellClassRules}
              ref={gridRef} // Ref for accessing Grid's API
              rowData={Data} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              onGridReady={onGridReady}
              gridOptions={gridOptions}
              suppressScrollOnNewData={true}
              getRowHeight={getRowHeight}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={10}
            />
          </div>
        </div>
        <style>
          {`
           .ag-theme-alpine .ag-root-wrapper {
             border: none;
           }
          `}
          {`
            .my-header-class {
              background-color: white;
            }
          `}
        </style>
      </div>
    </div>
  );
}
